
import { Button, TextField, CircularProgress } from '@material-ui/core';
import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@material-ui/core';
import Layout from './Layout';

export const Devices = () => {
  const [envId, setEnvId] = useState('');
  const [apiResponse, setapiResponse] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isInputEmpty, setIsInputEmpty] = useState(false);

  const baseUrl =
    window.environment === 'dev'
      ? 'https://dev.phyfarm.com/'
      : 'https://v3.api.phyfarm.com/';

  const handleClick = () => {
    setLoading(true);

    if (!envId) {

      setIsInputEmpty(true);
      setLoading(false);
      return;
    }

    setIsInputEmpty(false);

    const requestOptions = {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        envId: envId,
      }),
    };

    fetch(baseUrl + 'api/device/listDevicesByEnv', requestOptions)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        setapiResponse(data);
        setLoading(false);
      })
      .catch(error => {
        setError(error);
        setLoading(false);
      });
  };

  const handleDelete = (item) => {
    const deleteOptions = {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        deviceID: item._id,
        rev: item._rev,
      }),
    };

    fetch(baseUrl + 'api/device/deleteDeviceById', deleteOptions)
      .then(deleteResponse => deleteResponse.json())
      .then(res => {
        handleClick();
      })
      .catch(error => setError(error));
  };

  return (
    <>
      <Layout>
        <div style={{ textAlign: 'center', margin: 75 }}>
          <Typography variant="h5" style={{ marginBottom: 20, marginTop: 100 }}>
            List of Devices - ENV Address
          </Typography>
          <TextField
            label="ENV Address"
            variant="outlined"
            id="envId"
            type="text"
            value={envId}
            onChange={e => setEnvId(e.target.value.trim())}
            style={{ marginTop: 10 }}
            error={isInputEmpty}
            helperText={isInputEmpty ? 'Please enter ENV ID' : null}
          />
          <br />
          <Button
            style={{ marginTop: 20 }}
            onClick={handleClick}
            variant="contained"
            color="primary"
          >
            Submit
          </Button>
        </div>
        <div>
          {loading ? (
            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <CircularProgress />
            </div>
          ) : (
            <TableContainer component={Paper} style={{ marginTop: 10 }}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Device ID
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Env ID
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Name
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Mac Address
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Type
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Status
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                      Remove
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {apiResponse &&
                    apiResponse.data &&
                    Array.isArray(apiResponse.data.devices) && apiResponse.data.devices.length > 0 ? (
                    apiResponse.data.devices.map(item => (
                      <TableRow
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        key={item._id}
                      >
                        <TableCell align="center">{item._id}</TableCell>
                        <TableCell align="center">{item.envId}</TableCell>
                        <TableCell align="center">{item.name}</TableCell>
                        <TableCell align="center">{item.macAddress}</TableCell>
                        <TableCell align="center">{item.type}</TableCell>
                        <TableCell align="center">
                          {item.online ? (
                            <span style={{ color: 'green' }}>TRUE</span>
                          ) : (
                            <span style={{ color: 'red' }}>FALSE</span>
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => handleDelete(item)}
                          >
                            Delete
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={7}>
                        {apiResponse &&
                          apiResponse.data &&
                          apiResponse.data.devices &&
                          apiResponse.data.devices.length === 0 ? (
                          <Typography variant="subtitle1">
                            No data available
                          </Typography>
                        ) : null}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      </Layout>
    </>
  );
};
